<template>
    <div>
        <!-- Modal -->
        <div id="selectProposalTemplateGroupModal" class="modal fade" role="dialog">
            <div class="modal-dialog">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">Select proposal section content</h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="w-1/4 mr-4 hidden lg:inline">
                            <multiselect
                                id="proposalTemplateGroupListing"
                                v-model="selectedProposalTemplateGroup"
                                :options="proposalTemplateGroups"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick Proposal Section Content"
                                :showLabels="false"
                                label="name"
                                track-by="id"
                                :preselect-first="false"
                                @select="changeProposalTemplateGroup()"
                            >
                            </multiselect>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button id="select-proposal-template-group" name="save-as-template"
                                @click.prevent="closeSelectProposalTemplateGroupModal()"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Save
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div id="templateRenameModal" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-lg">
                            Rename Content
                        </h4>
                        <button type="button" dusk="modal-close-button"
                                class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                data-dismiss="modal">close
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @keydown="templateForm.errors.clear($event.target.name)">
                            <div class="mb-2">
                                <div class="form-group">
                                    <input v-model="templateRename" class="form-control"
                                           type="text"
                                           id="template_rename">
                                    <input type="hidden">

                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button id="rename-template-save" name="save-as-template"
                                @click.prevent="renameTemplate"
                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                            Update
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="">

        <div>
            <!-- Modal -->
            <div id="templateNameModal" class="modal fade" role="dialog">
                <div class="modal-dialog modal-md">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-lg">
                                Save Content
                            </h4>
                            <button type="button" dusk="modal-close-button"
                                    class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                    data-dismiss="modal">close
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @keydown="templateForm.errors.clear($event.target.name)">
                                <div class="mb-2" style="overflow: hidden;width: 100%;">
                                    <div class="form-group">
                                        <p>Content name</p>
                                        <input v-model="templateForm.template_name" class="form-control"
                                               :class="{'border-red': templateForm.errors.has('template_name')}" type="text"
                                               id="template_name">
                                    </div>
                                    <div class="text-red text-xs" v-if="templateForm.errors.has('template_name')">
                                        {{ templateForm.errors.get('template_name') }}
                                    </div>
                                </div>
                                <div class="mb-2">
                                    <div class="form-group proposalTemplateGroupListingClass">
                                        <p>Proposal section content</p>
                                        <multiselect
                                            id="proposalTemplateGroupListingModal"
                                            v-model="selectedProposalTemplateGroup"
                                            :options="proposalTemplateGroups"
                                            :multiple="false"
                                            :close-on-select="true"
                                            :clear-on-select="false"
                                            :preserve-search="false"
                                            :taggable="false"
                                            open-direction="below"
                                            placeholder="Pick Proposal Section Content"
                                            :showLabels="false"
                                            label="name"
                                            track-by="id"
                                            :preselect-first="false"
                                        >
                                        </multiselect>
                                        <button id="add-new-template-group" name="add-new-template-group" title="Create new proposal section content"
                                                @click.prevent="openTemplateGroupCreation"
                                                class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                            +
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button id="save-as-template" name="save-as-template" type="button"
                                    @click.prevent="saveAsTextTemplate"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="templateGroupCreation" class="modal fade" role="dialog">
                <div class="modal-dialog modal-md">
                    <!-- Modal content-->
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-lg">
                                Create new proposal section content
                            </h4>
                            <button type="button" dusk="modal-close-button"
                                    class="material-icons focus:outline-none text-grey-darkest hover:text-grey-darkest"
                                    data-dismiss="modal" @click="closeTemplateGroupNamePopup()">close
                            </button>
                        </div>
                        <div class="modal-body">
                            <form @keydown="templateForm.errors.clear($event.target.name)">
                                <div class="mb-2" style="overflow: hidden;width: 100%;padding-top: 10px;">
                                    <div class="form-group">
                                        <p>Section content name</p>
                                        <input v-model="createTemplateGroupName" class="form-control"
                                               :class="{'border-red': templateForm.errors.has('template_name')}" type="text"
                                               id="create_template_group_name">
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button id="save-create-template-group" name="save-create-template-group"
                                    @click.prevent="saveCreateTemplateGroup()"
                                    class="bg-followup-nav hover:bg-followup-nav-darker px-3 py-1 rounded-full text-white focus:outline-none">
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-2xl bg-primary border-b-2 border-followup-nav px-3 py-2 text-white" v-if="!tempSection.type_quote">
                <div class="col-md-3 inline-block float-left section-title">
                    {{tempSection.name}}
                </div>
                <div class="col-md-7 inline-block float-left templateDiv">
                    <b-dropdown toggle-class="templateDropDown" dropright id="dropdown-1" :text="templateSelector" class="">
                        <span v-if="tempSection.all_templates.length > 0">
                            <b-dropdown-item class="dropdownCustomItem" @click="deselectedTemplateDropdown()"><span class="templateName deselectTemplate">Deselect Content</span></b-dropdown-item>
                            <span v-for="templateItem in tempSection.all_templates">
                                <b-dropdown-item class="dropdownCustomItem" :id="'contentId-'+templateItem.id"><span @click="selectedTemplateDropdown(templateItem.id)" class="templateName">{{templateItem.template_name}}</span><i v-if="role" class="fa fa-trash templateDelete" @click="removeTemplate(templateItem.id)" aria-hidden="true"></i><i v-if="role" class="fa fa-pencil templateDelete templateRename" @click="renameTemplateModal(templateItem)" aria-hidden="true"></i></b-dropdown-item>
                            </span>
                        </span>
                        <span v-else>
                                <b-dropdown-item class="dropdownCustomItem"><span class="templateName">No content has been saved yet.</span></b-dropdown-item>
                            </span>
                    </b-dropdown>
                    <button @click="updateTemplate" v-if="selectedTemplate && role" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn" id="updateContentButton">
                        Update Content
                    </button>
                    <button v-if="role" @click="openSaveAsTemplateModal" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn" id="saveNewContentButton">
                        Save New Content
                    </button>
                </div>
                <div class="col-md-2 inline-block text-right pr-0">
                    <span class="text-sm">{{savingPrizmDoc}}</span>
                    <button @click="saveCustomSection" class="btn btn-primary rounded-full ml-2 proposal-editor-save-btn" id="saveSectionButton">
                        {{saveButtonText}}
                    </button>
                </div>
            </div>

            <div v-if="tempSection.type_text" class="card bg-white shadow w-100">
                <div class="">
                    <div class="">
                    <prizm-editor :section="section" :proposal="proposal" :selected-proposal-type="selectedProposalType" :user="user" :all-custom-signatures="allCustomSignatures"></prizm-editor>
                    </div>
                </div>
            </div>

            <div v-if="tempSection.type_sheet" class="card bg-white shadow w-100">
                <div class="">
                    <div class="">
                        <prizm-sheet :section="section" :proposal="proposal"></prizm-sheet>
                    </div>
                </div>
            </div>

            <div v-if="tempSection.type_pdf" class="card bg-white shadow w-100">
                <div class="card-body">
                    <file-pond
                        name="file"
                        ref="pond"
                        :server="server"
                        :onprocessfile="handleOnProcessFile"
                        allowRevert="false"
                        class-name="my-pond"
                        allowMultiple="false"
                        dropOnElement="true"
                        dropOnPage="true"
                        label-idle="Drop or select a pdf"
                        accepted-file-types="application/pdf"
                        labelFileTypeNotAllowed="Invalid File Type"
                        fileValidateTypeLabelExpectedTypes="Only PDFs Are Allowed."/>
                </div>
                <div v-if="tempSection.url" class="card-footer">
                    <button @click="removePDFFromSection" class="btn btn-outline-primary rounded-full mr-2 mb-2 float-right">
                        Remove PDF
                    </button>
                    <iframe :src="tempSection.url" class="reports-frame-style" style="height:100vh"/>
                </div>
            </div>

            <div v-if="tempSection.type_photo" class="card bg-white shadow w-100">
                <div class="">
                    <div class="p-4">
                        <proposal-generator-photo-type-selection-section :section="sectionDataForPhoto" :proposal="proposal"></proposal-generator-photo-type-selection-section>
                    </div>
                </div>
            </div>

            <div v-if="tempSection.type_quote" class="border-1 px-2 rounded">
                <proposal-generator-quote-section
                    :section="section"
                    :proposal="proposal"
                    :formatted-sales-taxes-for-quote="formattedSalesTaxesForQuote"
                    :quote-comment-templates="quoteCommentTemplates"
                ></proposal-generator-quote-section>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
    import QuoteDetailsSection from './proposal-generator-quote-details-sub-custom'
    import Form from "../../utils/form";
    import Multiselect    from 'vue-multiselect';
    import Swal from "sweetalert2";
    import axios from "axios";
    let token = document.head.querySelector('meta[name="csrf-token"]');
    import PrizmEditor from "../shared/prizm-editor";
    import ProposalGeneratorPhotoTypeSelectionSection from "./proposal-generator-photo-type-selection-section.vue";
    import ProposalGeneratorQuoteSection from "./proposal-generator-quote-section.vue";

    export default {
        props: ['section', 'proposal', 'team', 'role', 'selectedTemplateObject','tempProposal', 'selectedProposalType', 'formattedSalesTaxesForQuote', 'quoteCommentTemplates', 'user', 'allCustomSignatures'],
        components: {ProposalGeneratorQuoteSection, ProposalGeneratorPhotoTypeSelectionSection, PrizmEditor, Multiselect},
        data() {
            return {
                resourceFiles: this.proposal.resource_files,
                revertedResources: [],
                data_loading: false,
                hasOneFile: (this.section.url && this.section.type_pdf)? true:false,
                signatureButton: false,
                tempSection: {
                    uniqueIdentifier: this.section.uniqueIdentifier,
                    id: this.section.id,
                    proposal_id: this.section.proposal_id,
                    name: this.section.name,
                    include_in_report: this.section.include_in_report,
                    order: this.section.order,
                    tag: this.section.tag,
                    deleteable: this.section.deleteable,
                    text: (this.section.text)? this.section.text:'',
                    token: this.section.token,
                    url: this.section.url,
                    type_text: this.section.type_text,
                    type_authorization: this.section.type_authorization,
                    type_pdf: this.section.type_pdf,
                    type_quote: this.section.type_quote,
                    type_sheet: this.section.type_sheet,
                    quote: this.section.quote,
                    template_name: this.section.template_name,
                    signature_section: this.section.signature_section,
                    proposal_template_id: this.section.proposal_template_id,
                    all_templates: [],
                    firstCheck: this.section.first_check,
                    type_photo: this.section.type_photo,
                    photo_page_id: this.section.photo_page_id,
                    photo_page_data: this.section.photo_page_data,
                    photo_page_url: this.section.photo_page_url,
                },
                editName: false,
                server: {
                    revert: (uniqueFileId, load, error) => {
                        let file = JSON.parse(uniqueFileId).section;
                        axios.delete(route('proposal.delete-file-custom-section', {
                            proposal: this.proposal.id,
                            token: file.token,
                        }))
                            .catch((err) => error(err.response.message));
                        load();
                    },
                    process: (fieldName, file, metadata, load, error, progress) => {
                        const formData = new FormData();
                        formData.append('file', file, file.name);
                        const request = new XMLHttpRequest();
                        request.open('POST', '/proposal/' + this.proposal.id + '/proposal-custom-section/' + this.tempSection.id + '/upload-file');
                        let token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
                        request.setRequestHeader('X-CSRF-TOKEN', token);
                        let self = this;
                        request.upload.onprogress = (e) => {
                            progress(e.lengthComputable, e.loaded, e.total);
                        };
                        request.onload = function () {
                            if (request.status >= 200 && request.status < 300) {
                                load(request.responseText);
                                self.hasOneFile = true;
                                let data = JSON.parse(request.responseText)
                                self.tempSection.url = data.section.url;
                                self.fetchPDFUrlForPDFSection();
                            } else {
                                error('oh no');
                            }
                        };
                        request.send(formData);
                    }
                },
                templateForm: new Form({
                    template_name: this.section.template_name,
                    template_text: this.section.text,
                    template_type: 'custom',
                    section_id: this.section.id,
                    is_standard: this.section.mark_standard,
                    template_group_id:'',
                    type_pdf:false
                }),
                selectedTemplate: null,
                allTemplates: this.section.all_templates,
                signature: this.section.signature_section,
                showUpdateTemplateButton:false,
                templateSelector:'Choose Content',
                showSaveTemplateButton:false,
                sectionSaved:true,
                saveButtonText:'Save',
                templateIsSelected:false,
                appliedTemplateCounter:1,
                templateRename:'',
                templateRenameId:'',
                proposalTemplateGroups:[],
                selectedProposalTemplateGroup:null,
                createTemplateGroupName:'',
                savingPrizmDoc:'Saved',
                sectionDataForPhoto: this.section,
            }
        },
        created() {
        },
        mounted() {
            Bus.$emit('fetchPhotoData', true);
            this.templateSelector = 'Choose Content';
            this.getSectionType();
            Bus.$on('signature', data => {
                this.tempSection.signature_section = data;
                this.signature = this.tempSection.signature_section;
            });

            Bus.$emit('signature', this.section.signature_section);
            if(!this.tempSection.type_photo){
                Bus.$emit('allTemplates', {type: 'custom', value: this.allTemplates, proposal: null, selectedTemplateValue:null});
            }

            Bus.$on('customSectionChangedName', data => {
                this.tempSection.name = data;
            });

            // Bus.$on('newEditorData', data => {
            //     this.tempSection.text = data;
            // });
            Bus.$on('customSectionType-'+this.section.id, data => {
                this.toggleType(data);
            });
            if(!this.tempSection.type_photo) {
                this.selectAppliedTemplate();

                if (this.selectedTemplateObject.length > 0) {
                    this.selectedTemplateObject.forEach(item => {
                        if (item.type == 'custom' && item.section_id == this.section.id) {
                            this.sectionSaved = false;
                            this.saveButtonText = 'Save';
                            this.saveButtonBlink();
                            this.selectedTemplateByMethod(item.template_id);
                        }
                    });
                }
            }

            Bus.$on('sectionMarkedAsStandard', data => {
                this.getStandardCustomSectionTemplate()
            });

            Bus.$on('sectionUnmarkedAsStandard', data => {
                this.tempSection.all_templates = this.section.all_templates;
            });

            Bus.$on('saveNameFetchTemplates', data => {
                this.getStandardCustomSectionTemplate();
            });
            if(!this.tempSection.type_photo) {
                this.fetchAllProposalTemplateGroup();


                Bus.$on('assignTemplateGroup', data => {
                    $('#selectProposalTemplateGroupModal').modal('show');
                });

                Bus.$on('refetchTemplateWhenTemplateGroupUnassigned', data => {
                    this.getStandardCustomSectionTemplate();
                });

                Bus.$on('afterContentSaved', data => {
                    this.allTemplates = data.allProposalContents;
                    this.tempSection.all_templates = data.allProposalContents;
                    Bus.$emit('allTemplates', {
                        type: 'custom',
                        value: this.allTemplates,
                        proposal: null,
                        selectedTemplateValue: data.proposalContent.id
                    });
                    this.selectedTemplateByMethod(data.proposalContent.id);
                });

                this.getStandardCustomSectionTemplate();

                Bus.$on('savingPrizmDoc', data => {
                    Bus.$emit('changeReviewButtonPrizm', true);
                    if (data == 'Saved') {
                        $('#saveNewContentButton').prop("disabled", false);
                        $("#updateContentButton").prop("disabled", false);
                        Bus.$emit('sectionSaveStatus', {'status': 'saved', 'sectionUniqueId': this.section.id});
                    } else {
                        $("#saveNewContentButton").prop("disabled", true);
                        $("#updateContentButton").prop("disabled", true);
                        Bus.$emit('sectionSaveStatus', {'status': 'failed', 'sectionUniqueId': this.section.id});
                    }
                    this.savingPrizmDoc = data;
                });

                Bus.$on('contentAppliedSuccessfully', data => {
                    this.selectedTemplateByMethod(data.content.id);
                });

                this.fetchPDFUrlForPDFSection();

                Bus.$on('enableSaveContentButton', data => {
                    this.enableContentSaveButton();
                });

                Bus.$on('applyFirstContent', data => {
                    //this.checkForFirstContentToApply();
                });
            }
                Bus.$on('updateSectionForHeaderFooterImage', data => {
                    Bus.$emit('updateSectionForHeaderFooterImageSection', data);
                });


        },
        methods: {
            toolButton(button, text){
                var data = [];
                data['button'] = button;
                data['text'] = text;
                Bus.$emit('toolButton', data);
            },
            selectAppliedTemplate(){
                this.tempSection.all_templates = this.allTemplates;
                if (this.allTemplates && this.tempSection.proposal_template_id != null) {
                    this.selectedTemplate = this.allTemplates.find(template => template.id == this.tempSection.proposal_template_id)
                }
            },
            fireSuccessToast(message) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });

                Toast.fire({
                    type: 'success',
                    title: message,
                });
            },
            fireErrorToast(message) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 2000
                });

                Toast.fire({
                    type: 'error',
                    title: message,
                });
            },
            deleteSection(section) {
                this.$emit('deleteCustomSection', section);
            },
            saveCustomSection() {
                if(this.tempSection.type_text){
                    Bus.$emit('savePrizmEditorDocumentBtn', true);
                }else if(this.tempSection.type_sheet){
                    Bus.$emit('savePrizmSheetBtn', true);
                }else if(this.tempSection.type_photo){
                    Bus.$emit('savePhotoSectionBtn-'+this.tempSection.id, true);
                }
                Bus.$emit('changeReviewButtonPrizm', true);

                if(this.tempSection.type_pdf){
                    this.savingPrizmDoc = 'Saving...';
                    setTimeout(()=>{
                        this.savingPrizmDoc = 'Saved';
                    }, 2000);
                }
            },
            toggleType(type) {
                console.log(type);
                if (type === 'text') {
                    this.tempSection.type_pdf           = false;
                    this.tempSection.type_sheet         = false;
                    this.tempSection.type_text          = true;
                    this.tempSection.type_photo         = false;
                    this.tempSection.type_quote         = false;

                    Bus.$emit('showButton', {
                        button: 'template',
                        proposal_template_id: this.tempSection.proposal_template_id
                    });
                } else if (type === 'pdf') {
                    this.tempSection.type_text          = false;
                    this.tempSection.type_sheet         = false;
                    this.tempSection.type_pdf           = true;
                    this.tempSection.type_photo         = false;
                    this.tempSection.type_quote         = false;
                    Bus.$emit('showButton', {button: 'hideTemplate'});
                    Bus.$emit('showButton', {button: 'hideSaveTemplate'});
                }else if (type === 'sheet') {
                    this.tempSection.type_pdf           = false;
                    this.tempSection.type_text          = false;
                    this.tempSection.type_photo         = false;
                    this.tempSection.type_quote         = false;
                    this.tempSection.type_sheet          = true;
                }else if (type === 'photo') {
                    this.tempSection.type_pdf           = false;
                    this.tempSection.type_text          = false;
                    this.tempSection.type_sheet         = false;
                    this.tempSection.type_quote         = false;
                    this.tempSection.type_photo         = true;
                }else if(type === 'quote'){
                    this.tempSection.type_pdf           = false;
                    this.tempSection.type_text          = false;
                    this.tempSection.type_sheet         = false;
                    this.tempSection.type_quote         = true;
                    this.tempSection.type_photo         = false;
                }
                this.changeSectionType(type);
                this.getStandardCustomSectionTemplate();
                console.log(this.tempSection.type_pdf, this.tempSection.type_text, this.tempSection.type_sheet);
                this.$forceUpdate();
            },
            handleOnProcessFile() {
                this.$refs.pond.removeFile();
                this.saveCustomSection();
            },
            openSaveAsTemplateModal() {
                this.templateForm.errors.clear();
                this.templateForm.template_name = null;
                $("#templateNameModal").modal("show");
            },
            saveAsTextTemplate() {
                $('#save-as-template').prop( "disabled", true );
                if(this.tempProposal.locked){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                if(this.tempSection.type_text){
                    Bus.$emit('saveContentEditor', {content_group_id:this.selectedProposalTemplateGroup,template_name:this.templateForm.template_name});
                }else if(this.tempSection.type_sheet){
                    Bus.$emit('saveContentSheet', {content_group_id:this.selectedProposalTemplateGroup,template_name:this.templateForm.template_name});
                }else if(this.tempSection.type_pdf){
                    this.savePDFContent();
                }
                Bus.$emit('allTemplates', {type: 'custom', value: this.allTemplates,  proposal: null, selectedTemplateValue:null});
                this.$emit('customSectionChanged', this.tempSection, false);
            },
            updateTemplate() {
                if(this.tempProposal.locked){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                if(this.tempSection.type_text){
                    Bus.$emit('updateContent', {content_id:this.selectedTemplate.id});
                }else if(this.tempSection.type_sheet){
                    Bus.$emit('updateSheetContent', {content_id:this.selectedTemplate.id});
                }else if(this.tempSection.type_pdf) {
                    this.updatePDFContent();
                }
            },
            removeTemplate(id) {
                this.tempSection.all_templates.forEach(item => {
                    if(item.id == id){
                        this.selectedTemplate = item;
                    }
                });
                if(!this.selectedTemplate) {
                    this.fireErrorToast('Please select a template to delete.');
                }else {

                    Swal.fire({
                        title: "Are you sure?",
                        text: "Once deleted, you will not be able to recover this content!",
                        icon: "warning",
                        buttons: true,
                        showCancelButton: true,
                        confirmButtonColor: 'red',
                        confirmButtonText: 'I\'m sure!',
                        closeOnConfirm: true,
                        closeOnCancel: true,
                    }).then(result => {
                        if (result.value) {
                            this.templateForm.post('/proposal/'+ this.proposal.id +'/proposal-template/' + this.selectedTemplate.id + '/delete')
                                .then((data) => {
                                    if (data.status === 'success') {
                                        this.fireSuccessToast(data.message);
                                        this.tempSection.proposal_template_id = null;
                                        this.selectedTemplate = null;
                                        this.allTemplates = data.templates;
                                        Bus.$emit('allTemplates', {type: 'custom', value: this.allTemplates,  proposal: data.proposal, selectedTemplateValue:null});
                                        Bus.$emit('showButton', {
                                            button: 'template',
                                            proposal_template_id: this.tempSection.proposal_template_id
                                        });
                                        // this.getStandardCustomSectionTemplate();
                                        this.templateSelector='Choose Content';
                                        this.getStandardCustomSectionTemplate();
                                        this.deselectedTemplateDropdown();
                                    } else {
                                        this.fireErrorToast(data.message);
                                    }
                                });
                        }
                    });
                }
            },
            applyTemplate() {
                if (this.selectedTemplate) {
                    this.tempSection.proposal_template_id = this.selectedTemplate.id
                    this.tempSection.text = this.selectedTemplate.text.trim();
                    Bus.$emit('showButton', {
                        button: 'template',
                        template_applied: 1,
                        proposal_template_id: (this.tempSection.proposal_template_id) ? this.tempSection.proposal_template_id : null
                    });
                }
            },
            deleteProposal() {
                let self = this;
                Swal.fire({
                    title             : "Are you sure?",
                    text              : "Once deleted, you will not be able to recover this proposal!",
                    icon              : "warning",
                    buttons           : true,
                    showCancelButton  : true,
                    confirmButtonColor: 'red',
                    confirmButtonText : 'I\'m sure!',
                    closeOnConfirm    : true,
                    closeOnCancel     : true,
                }).then(result => {
                    if (result.value) {
                        axios.delete(route('proposal.destroy', self.proposal.id))
                            .then((response) => {
                                if (response.data.status === 'success') {
                                    window.location = '/project/' + response.data.project_id + '/edit';
                                } else {
                                    self.initTempProposal(response.data.proposal);
                                    self.fireErrorToast(response.data.message);
                                }
                            });
                    }
                });
            },
            unlock() {
                let self = this;
                axios.put('/proposal/' + self.proposal.id + '/unlock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            window.location.reload();
                        } else {
                            self.fireErrorToast(response.data.message);
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
            lock() {
                let self = this;
                axios.put('/proposal/' + self.proposal.id + '/lock')
                    .then((response) => {
                        if (response.data.status === 'success') {
                            self.fireSuccessToast(response.data.message);
                            window.location.reload();
                        } else {
                            self.fireErrorToast(response.data.message);
                            self.initTempProposal(response.data.proposal);
                        }
                    });
            },
            selectedTemplateDropdown(selectedValue){
                if(this.tempProposal.locked){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                if(this.tempSection.type_text){
                    Bus.$emit('selectContentToApply', selectedValue);
                }else if(this.tempSection.type_sheet){
                    Bus.$emit('selectSheetContentToApply', selectedValue);
                }else if(this.tempSection.type_pdf){
                    this.tempSection.all_templates.forEach(item => {
                        if(item.id == selectedValue){
                            let sectionType = 'text';
                            if(this.tempSection.type_pdf){
                                sectionType = 'pdf';
                            }
                            if(this.tempSection.type_sheet){
                                sectionType = 'sheet';
                            }
                            axios.get('/proposal/get-template-text/' + selectedValue+'/'+this.section.id+'/'+sectionType).then((response) => {
                                if (response.data.status === 'success') {
                                    this.tempSection.text = response.data.text;
                                    this.fireSuccessToast(response.data.message);
                                    if(this.tempSection.type_pdf){
                                        this.tempSection.url = response.data.template.pdf_url;
                                    }
                                    Bus.$emit('templateIsSelected', response.data.text);
                                }else{
                                    this.tempSection.text = item.text;
                                    Bus.$emit('templateIsSelected', item.text);
                                }
                            });
                            this.selectedTemplate = item;
                            this.tempSection.proposal_template_id = item.id;
                            this.templateSelector=item.template_name;
                            this.showSaveTemplateButton = false;
                            this.templateIsSelected = true;
                            Bus.$emit('selectedTemplateObjectEmit', {'template_id':item.id, 'section_id':this.section.id, 'type':item.type, 'selectedValue':selectedValue});
                        }
                    });
                }
            },
            saveButtonBlink(){
                for (var i in CKEDITOR.instances) {
                    var currentData = CKEDITOR.instances[i].getData();
                }
                if(!this.sectionSaved){
                    if(!this.templateIsSelected){
                        this.showSaveTemplateButton = true;
                    }else if(this.selectedTemplate && this.templateIsSelected && this.tempSection.text !== currentData.trim()){
                        this.showUpdateTemplateButton = true;
                    }
                    // const elm= $('#saveSectionButton');
                    // elm.addClass('bgglow');
                }
            },
            deselectedTemplateDropdown(){
                if(this.tempProposal.locked){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                this.tempSection.text = '';
                this.templateSelector='Choose Content';
                this.showSaveTemplateButton = true;
                this.templateIsSelected = false;
                Bus.$emit('templateIsSelected', '')
                Bus.$emit('deselectedTemplateObjectEmit', {'section_id':this.section.id});
                this.tempSection.proposal_template_id = null;
                this.selectedTemplate = null;
                this.deselectAllContent();
            },
            getStandardCustomSectionTemplate(){
                let sectionType = 1
                if(this.tempSection.type_pdf){
                    sectionType = 0;
                }
                if(this.tempSection.type_sheet){
                    sectionType = 2;
                }
                axios.get('/proposal/all-standard-section-templates/' + this.section.id +'/'+ sectionType)
                    .then((response) => {
                        if (response.data.status === 'success') {
                            this.tempSection.all_templates = response.data.data;
                            if(response.data.data.length > 0){
                                response.data.data.forEach(item => {
                                    if(item.id == response.data.section.proposal_template_id){
                                        this.templateSelector = item.template_name;
                                        this.selectedTemplateByMethod(item.id);
                                    }
                                });
                            }
                        } else {
                            this.tempSection.all_templates = [];
                        }
                    });
            },
            renameTemplateModal(template){
                $('#templateRenameModal').modal("show");
                this.templateRename = template.template_name;
                this.templateRenameId = template.id;
            },
            renameTemplate() {
                if(this.tempProposal.locked){
                    this.fireErrorToast('Proposal is locked.');
                    return false;
                }
                var templateData = {
                    'name':this.templateRename,
                    'id':this.templateRenameId
                };
                axios.post('/proposal-template/rename', templateData)
                    .then((data) => {
                        if (data.data.status == 'success') {
                            this.fireSuccessToast(data.data.message);
                            $("#templateRenameModal").modal("hide");
                            this.allTemplates = data.data.templates;
                            Bus.$emit('allTemplates', {type: 'introduction', value: this.allTemplates, proposal: null, selectedTemplateValue:null});
                            this.$emit('customSectionChanged', this.tempSection, false);
                            this.templateRename = '';
                            this.templateRenameId = '';
                            this.templateSelector = data.data.selectedTemplate.template_name;
                        } else {
                            this.fireErrorToast(data.data.message);
                        }
                    });
            },
            selectedTemplateByMethod(selectedValue){
                this.tempSection.all_templates.forEach(item => {
                    let sectionType = 'text';
                    if(this.tempSection.type_pdf){
                        sectionType = 'pdf';
                    }
                    if(this.tempSection.type_sheet){
                        sectionType = 'sheet';
                    }
                    if(item.id == selectedValue){
                        axios.get('/proposal/get-template-text/' + selectedValue+'/'+this.section.id+'/'+sectionType).then((response) => {
                            if (response.data.status === 'success') {

                            }else{
                                this.tempSection.text = item.text;
                            }
                        });
                        this.selectedTemplate = item;
                        this.tempSection.proposal_template_id = item.id;
                        this.templateSelector=item.template_name;
                        this.showSaveTemplateButton = false;
                        this.templateIsSelected = true;
                        Bus.$emit('selectedTemplateObjectEmit', {'template_id':item.id, 'section_id':this.section.id, 'type':item.type});
                    }
                });
            },
            fetchAllProposalTemplateGroup(){
                axios.post(route('api.proposal-template-group.all-templates-group-for-proposal'), {section:this.section.id}).then(({data}) => {
                    if(data.status == 'success'){
                        this.proposalTemplateGroups = data.templateGroups;
                        if(data.templateGroups.length > 0){
                            data.templateGroups.forEach(item => {
                                if(data.section.proposal_template_group_id == item.id){
                                    this.selectedProposalTemplateGroup = item;
                                    this.getStandardCustomSectionTemplate();
                                }
                            });
                        }
                    }else{
                        this.fireErrorToast(data.message);
                    }
                });
            },
            changeProposalTemplateGroup(){
                this.$nextTick(() => {
                    axios.post(route('api.proposal-template-group.select-templates-group-for-proposal'), {section:this.section.id, templateGroup:this.selectedProposalTemplateGroup}).then(({data}) => {
                        if(data.status == 'success'){
                            this.proposalTemplateGroups = data.templateGroups;
                            if(data.templateGroups.length > 0){
                                data.templateGroups.forEach(item => {
                                    if(data.section.proposal_template_group_id == item.id){
                                        this.selectedProposalTemplateGroup = item;
                                        this.getStandardCustomSectionTemplate();
                                        //this.checkForFirstContentToApply();
                                    }
                                });
                            }
                            this.sendProposalObject(data.proposal);
                        }else{
                            this.fireErrorToast(data.message);
                        }
                    });
                });
            },
            closeSelectProposalTemplateGroupModal(){
                this.fireSuccessToast('Proposal section content assigned.');
                $('#selectProposalTemplateGroupModal').modal('hide');
            },
            sendProposalObject(proposal){
                Bus.$emit('sectionProposalTemplateGroupChanged', proposal);
            },
            openTemplateGroupCreation(){
                $('#templateNameModal').modal('hide');
                $('#templateGroupCreation').modal('show');
            },
            closeTemplateGroupNamePopup(){
                $('#templateGroupCreation').modal('hide');
                this.createTemplateGroupName = '';
                $('#templateNameModal').modal('show');
            },
            saveCreateTemplateGroup(){
                if(this.createTemplateGroupName.trim() == null || this.createTemplateGroupName.trim() == ''){
                    this.fireErrorToast('Please enter section content name');
                    return false;
                }

                axios.post(route('api.proposal-template-group.create-from-proposal'), {section:this.section.id, name:this.createTemplateGroupName}).then(({data}) => {
                    if(data.status == 'success'){
                        this.proposalTemplateGroups = data.listProposalTemplateGroups;
                        this.selectedProposalTemplateGroup = data.proposalTemplateGroup;
                        this.fireSuccessToast(data.message);
                        $('#templateGroupCreation').modal('hide');
                        $('#templateNameModal').modal('show');
                    }else{
                        this.fireErrorToast(data.message);
                    }
                });
            },
            changesOccur(){
                this.sectionSaved = false;
                this.saveButtonText = 'Save';
                this.saveButtonBlink();
            },
            changeSectionType(type){
                axios.post(route('proposal.change-section-type'), {sectionId:this.section.id, type:type})
                    .then((response) => {
                        Bus.$emit('sectionProposalTemplateGroupChangedParent', response.data.proposal)
                });
            },
            getSectionType(){
                axios.post(route('proposal.get-section-type'), {sectionId:this.section.id})
                    .then((response) => {
                    this.tempSection.type_text = (response.data.customSectionType.type_text == 1)? true:false;
                    this.tempSection.type_pdf = (response.data.customSectionType.type_pdf == 1)? true:false;
                    this.tempSection.type_sheet = (response.data.customSectionType.type_sheet == 1)? true:false;
                    this.tempSection.type_photo = (response.data.customSectionType.type_photo == 1)? true:false;
                    this.tempSection.firstCheck = response.data.customSectionType.first_check;
                    this.tempSection.photo_page_id = response.data.customSectionType.photo_page_id;
                    this.sectionDataForPhoto.photo_page_id = response.data.customSectionType.photo_page_id;
                    // this.sectionDataForPhoto.photo_page_data = (response.data.customSectionType.photo_page_data)? JSON.parse(response.data.customSectionType.photo_page_data):null;
                    if(response.data.customSectionType.type_pdf == 1){
                        this.fetchPDFUrlForPDFSection();
                    }
                });
            },
            savePDFContent(){
                if(!this.hasOneFile && this.tempSection.type_pdf){
                    this.fireErrorToast('Please upload PDF to save  content.');
                } else{
                    if(this.selectedProposalTemplateGroup){
                        this.templateForm.template_group_id = this.selectedProposalTemplateGroup.id;
                    }
                    this.templateForm.template_text = this.tempSection.text;
                    if(this.tempSection.type_pdf){
                        this.templateForm.type_pdf = true;
                    }
                    this.templateForm.post('/proposal-template/save')
                        .then((data) => {
                            if (data.status === 'success') {
                                this.fireSuccessToast(data.message);
                                $("#templateNameModal").modal("hide");
                                this.allTemplates = data.templates;
                                this.tempSection.all_templates = data.templates;
                                this.selectedTemplateDropdown(data.created_template.id);
                                this.fetchAllProposalTemplateGroup();
                                Bus.$emit('allTemplates', {type: 'custom', value: this.allTemplates,  proposal: null, selectedTemplateValue:null});
                                this.$emit('customSectionChanged', this.tempSection, false);
                                this.enableContentSaveButton();
                            }else{
                                this.fireSuccessToast(data.message);
                            }
                        });
                }
            },
            updatePDFContent(){
                if(!this.hasOneFile && this.tempSection.type_pdf){
                    this.fireErrorToast('Please upload PDF to save  content.');
                }else{
                    this.templateForm.template_text = this.tempSection.text;
                    if(this.tempSection.type_pdf){
                        this.templateForm.type_pdf = true;
                    }
                    this.templateForm.put('/proposal-template/' + this.selectedTemplate.id + '/update')
                        .then((data) => {
                            if (data.status === 'success') {
                                this.fireSuccessToast(data.message);
                                this.allTemplates = data.templates;
                                Bus.$emit('allTemplates', {type: 'custom', value: this.allTemplates,  proposal: null, selectedTemplateValue:null});
                                // this.$emit('customSectionChanged', this.tempSection, false);
                                for (var i in CKEDITOR.instances) {
                                    Bus.$emit('updatedSectionTemplate', CKEDITOR.instances[i].getData())
                                }
                                this.showUpdateTemplateButton = false;
                            }else{
                                this.fireSuccessToast(data.message);
                            }
                        });
                }
            },
            fetchPDFUrlForPDFSection(){
                this.$nextTick(() => {
                    if(this.tempSection.type_pdf){
                        //this.checkForFirstContentToApply();
                        axios.post(route('proposal.proposal-get-pdf-url'), {sectionId:this.section.id}).then((response) => {
                            this.tempSection.url = response.data.url;
                        });
                    }
                });
            },
            enableContentSaveButton(){
                $('#save-as-template').prop( "disabled", false );
            },
            deselectAllContent(){
                axios.post(route('proposal.proposal-deselect-content'), {sectionId:this.section.id}).then((response) => {
                    let customSection = response.data.proposal_custom_section;
                    if(customSection.type_pdf == 1){
                        this.tempSection.url = null;
                    }else if(customSection.type_sheet == 1){
                        Bus.$emit('deselectPrizmSheetContent', true);
                    }else if(customSection.type_text == 1){
                        Bus.$emit('deselectPrizmDocContent', true);
                    }
                    this.fireSuccessToast(response.data.message);
                });
            },
            removePDFFromSection(){
                axios.post(route('proposal.remove-section-pdf-file'), {sectionId:this.section.id}).then((response) => {
                    this.tempSection.url = null;
                    this.fireSuccessToast(response.data.message);
                    Bus.$emit('changeReviewButtonPrizm', true);
                });
            },
            checkForFirstContentToApply(){
                if(!this.selectedTemplate && this.tempSection.firstCheck == 1){
                    axios.post(route('proposal.check-first-content'), {sectionId:this.section.id}).then((response) => {
                        if(response.data.status == 'success'){
                            this.tempSection.firstCheck = 0;
                            this.selectedTemplateDropdown(response.data.content_id);
                        }
                    });
                }

            },
        },
        beforeDestroy () {
            Bus.$off('updateTemplate');
            Bus.$off('removeTemplate');
        },
    }
</script>

<style scoped>
    .reports-frame-style {
        height: 70vh;
        width: 100%;
        border: 1px solid grey;
        border-radius: 7px;
    }
    .resource-images-div {
        float: left;
        padding: 0 5px;
        margin-bottom: 10px;
        height: 100px;
        overflow:hidden;
    }
    .resource-images-div img{
        height:60px;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
    }
    span.resource-images-name {
        font-size: 10px;
        word-break: break-word;
    }
    .resource-images {
        height: 55px;
    }
    .tool-buttons {
        border: 1px solid #01b1af;
        margin: 0 5px;
        font-size: 12px;
        padding: 10px 0;
        color: #01b1af;
        text-align: center;
        margin-bottom: 9px;
        max-width: 93% !important;
        margin-right: 5px;
        margin-left: 7px;
    }
    .tool-buttons:hover {
        background-color: #01b1af1c;
        cursor: pointer;
    }
    .deleteBtn {
        color: #dc3545 !important;
        border-color: #dc3545 !important;
        max-width: 95% !important;
    }
    .deleteBtn:hover{
        background-color: #dc35451c !important;
    }
    .resource-images:hover {
        cursor: pointer;
    }
    .upload-icon-proposal {
        font-size: 18px;
        margin-left: 6px;
    }
    .upload-btn-proposal:hover{
        border: 1px solid #fff;
        padding: 0 10px;
        border-radius: 5px;
        background: #fff;
        color: #01b1af !important;
    }
    .upload-btn-proposal{
        border: 1px solid #fff;
        padding: 0 10px;
        border-radius: 5px;
        background: #01b1af;
        color: #fff !important;
        cursor: pointer;
    }
    .cke_editable p{
        margin:0 !important;
    }
    .proposal-editor-save-btn {
        background: #fff;
        border: 1px solid #01b1af;
        /*box-shadow: unset !important;*/
        color: #01b1af;
        font-size: 12px;
    }
    .proposal-editor-save-btn:hover {
        background: #01b1af;
        border: 1px solid #fff;
        box-shadow: unset !important;
        color: #fff;
    }
    .templateDelete {
        float: right;
        padding: 2px 9px;
        border-radius: 3px;
    }
    .templateDelete:hover {
        background: red;
        color: #fff;
    }
    .templateName {
        width: 75% !important;
        overflow: hidden;
        float: left;
        word-break: break-word;
        font-size: 13px;
    }
    .bgglow {
        -webkit-animation: bgglow 1500ms infinite;
        -moz-animation: bgglow 1500ms infinite;
        -o-animation: bgglow 1500ms infinite;
        animation: bgglow 1500ms infinite;
    }
    @-webkit-keyframes bgglow {
        0% { -webkit-box-shadow: 0 0 3px #00FF01; }
        50% { -webkit-box-shadow: 0 0 40px #00FF01; }
        100% { -webkit-box-shadow: 0 0 3px #00FF01; }
    }

    @-moz-keyframes bgglow {
        0% { -moz-box-shadow: 0 0 3px #00FF01; }
        50% { -moz-box-shadow: 0 0 40px #00FF01; }
        100% { -moz-box-shadow: 0 0 3px #00FF01; }
    }

    @-o-keyframes bgglow {
        0% { box-shadow: 0 0 3px #00FF01; }
        50% { box-shadow: 0 0 40px #00FF01; }
        100% { box-shadow: 0 0 3px #00FF01; }
    }

    @keyframes bgglow {
        0% { box-shadow: 0 0 3px #00FF01; }
        50% { box-shadow: 0 0 40px #00FF01; }
        100% { box-shadow: 0 0 3px #00FF01; }
    }

    .proposalTemplateGroupListingClass .multiselect {
        width: 88%;
        float: left;
    }

    button#add-new-template-group {
        float: right;
        border-radius: 50%;
        width: 42px;
        height: 42px;
    }

</style>
<style>
    .templateDropDown,
    .templateDropDown:hover,
    .templateDropDown:active,
    .templateDropDown:focus,
    .btn-secondary:not(:disabled):not(.disabled):active,
    .btn-secondary:not(:disabled):not(.disabled).active,
    .show > .btn-secondary.dropdown-toggle{
        background: #fff;
        color: #333;
        border:0;
        box-shadow: unset !important;
        font-size:13px;
    }
    .dropdownCustomItem .dropdown-item:hover,
    .dropdownCustomItem .dropdown-item:focus,
    .dropdownCustomItem .dropdown-item:target,
    .dropdownCustomItem .dropdown-item:active{
        text-decoration: none;
        background-color: transparent !important;
    }
    .dropdownCustomItem .dropdown-item, .dropdownCustomItem .dropdown-item {
        text-decoration: none;
        background-color: transparent !important;
    }
    ul.dropdown-menu.show {
        width: 300%;
    }
    .section-title{
        width: 100%;
        height: 35px;
        overflow: hidden;
        font-size: 18px !important;
        padding: 7px 0;
    }
    button#dropdown-1__BV_toggle_ {
        max-width: 140px;
        overflow: hidden;
    }
    .deselectTemplate{
        color: red !important;
    }
    .delete-resource-file-button {
        width: 20px;
        height: 20px;
        font-size: 12px;
        background: red;
        text-align: center;
        color: white;
        position: absolute;
        top: 0px;
        z-index: 999;
        display: none;
        cursor: pointer;
    }
    .templateRename:hover{
        background: #01b1af !important;
        color: #fff;
    }
    .templateDiv ul{
        min-width: 350px !important;
    }
    .proposal-edited-image-save{
        position: fixed;
        display: none;
        width: 100%;
        height: 100%;
        top:18px;
        left: 0;
        right: 0;
        bottom: 0;
    //background-color: rgba(0,0,0,0.5);
        z-index: 999;
        cursor: pointer;
        background: #ffffffd9;
    }
    .proposal-edited-image-save img{
        position: absolute;
        right: 42%;
        top: 28%;
    }
    .proposal-edited-image-save h1{
        position: absolute;
        color: #01b1af;
        top: 60%;
        right: 33%;
        font-weight: 200;
    }
</style>

